const shadowSelection = '0px 0px 0px 2px rgb(from var(--blue400) r g b / 0.08)';
const shadowSmall = '0px 0px 16px 0px rgb(from var(--superDark) r g b / 0.04)';
const shadowMedium = '0px 16px 40px 0px rgb(from var(--superDark) r g b / 0.16)';

export const SHADOW: Record<string, string> = {
    shadowSelection,
    shadowSmall,
    shadowMedium,
};
